import React from 'react';
import { Helmet } from 'react-helmet';

const SitelinksSearchBoxSchema = () => {
  const searchBoxData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "url": "https://www.tensorpilot.io/",
    "name": "TensorPilot",
    "alternateName": "TensorPilot",
    "description": "Desktop AI for Local Data, Code & Files",
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.tensorpilot.io/blog?search={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(searchBoxData)}
      </script>
    </Helmet>
  );
};

export default SitelinksSearchBoxSchema;
